import React, { useEffect, useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatZAR } from "../lib/api";

const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-ZA", { month: "long", year: "numeric" });

export default function DriverStatements() {
  const [statements, setStatements] = useState([]);
  const [downloading, setDownloading] = useState(null);

  useEffect(() => {
    api.get("/driver/statements").then((r) => setStatements(r.data || [])).catch(() => {});
  }, []);

  const download = async (month) => {
    setDownloading(month);
    try {
      const res = await api.get(`/driver/statements/${month}.pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `tadada-chauffeur-statement-${month}.pdf`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch {
      toast.error("Could not generate the statement");
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div className="rounded-2xl border border-[#E2E8F0] bg-white p-6" data-testid="driver-statements-card">
      <h3 className="font-display text-lg font-bold text-[#0a1f4d]">Monthly earnings statements</h3>
      <p className="text-sm text-[#64748B] mt-1">A PDF per month of your completed trips, days driven and chauffeur fees — handy for tax and record keeping.</p>
      {statements.length === 0 && <p className="text-sm text-[#64748B] mt-4" data-testid="driver-statements-empty">Your first statement appears after you complete a trip.</p>}
      <ul className="mt-4 space-y-2">
        {statements.map((m) => (
          <li key={m.month} className="flex items-center gap-3 text-sm rounded-xl border border-[#EEF2F7] px-4 py-3" data-testid={`driver-statement-${m.month}`}>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-[#0a1f4d]">{monthLabel(m.month)}</p>
              <p className="text-xs text-[#64748B]">{m.trips} trip{m.trips === 1 ? "" : "s"} · {formatZAR(m.fees)} in chauffeur fees</p>
            </div>
            <button onClick={() => download(m.month)} disabled={downloading === m.month} className="inline-flex items-center gap-1.5 text-xs font-bold text-[#0a1f4d] border border-[#E2E8F0] rounded-full px-3 py-1.5 hover:border-[#0a1f4d] disabled:opacity-60" data-testid={`driver-statement-download-${m.month}`}>
              {downloading === m.month ? <Loader2 size={12} className="animate-spin" /> : <FileDown size={12} />} PDF
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
